import Link from "next/link";
import { footerMenuList, socialIcons } from "../data/footer_data";
import { Typography } from "@material-tailwind/react";
import { isChildrenPageActive } from "../utils/daynamicNavigation";
import { useRouter } from "next/router";
import { Bit5Logo } from "./bit5Logo";

const Footer = () => {
  const route = useRouter();

  return (
    <>
      {/* <!-- Footer --> */}

      <footer className="dark:bg-jacarta-900 page-footer bg-white">
        <div className="container">
          <div className="grid grid-cols-3 gap-1 items-center pt-12 pb-6">
            <div className="col-span-3 md:col-span-1 justify-center text-center md:justify-start md:text-start flex">
              {/* <!-- Logo --> */}
              <a className="inline-block w-20" href="https://bit5.com">
                <Bit5Logo />
              </a>
            </div>

            <ul className="col-span-3 md:col-span-1 justify-center text-center md:justify-start md:text-start flex flex-col md:flex-row items-center">
              <li className="group">
                <Link href="/lend">
                  <a>
                    <button className="font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-jacarta-200 lg:px-5">
                      <span
                        className={
                          isChildrenPageActive(route.asPath, "/lend")
                            ? "text-accent dark:text-accent"
                            : ""
                        }
                      >
                        Lend
                      </span>
                    </button>
                  </a>
                </Link>
              </li>

              <li className="group">
                <Link href="/borrow">
                  <a>
                    <button className="font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-jacarta-200 lg:px-5">
                      <span
                        className={
                          isChildrenPageActive(route.asPath, "/borrow")
                            ? "text-accent dark:text-accent"
                            : ""
                        }
                      >
                        Borrow
                      </span>
                    </button>
                  </a>
                </Link>
              </li>

              <li className="group">
                <Link href="/account">
                  <a>
                    <button className="font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-jacarta-200 lg:px-5">
                      <span
                        className={
                          isChildrenPageActive(route.asPath, "/account")
                            ? "text-accent dark:text-accent"
                            : ""
                        }
                      >
                        Account
                      </span>
                    </button>
                  </a>
                </Link>
              </li>
            </ul>

            <div className="flex space-x-5 col-span-3 md:col-span-1 mt-6 md:mt-0 justify-center md:justify-end">
              {socialIcons.map((item) => {
                const { id, href, text } = item;
                return (
                  <Link href={href} key={id}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group cursor-pointer"
                    >
                      <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                        <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                      </svg>
                    </a>
                  </Link>
                );
              })}
            </div>

            {/* {footerMenuList.map((single) => (
              <div
                className={`col-span-full sm:col-span-3 md:col-span-2 ${single.diffClass}`}
                key={single.id}
              >
                <h3 className="font-display text-jacarta-700 mb-6 text-sm dark:text-white">
                  {single.title}
                </h3>
                <ul className="dark:text-jacarta-300 flex flex-col space-y-1">
                  {single.list.map((item) => {
                    const { id, href, text } = item;
                    return (
                      <li key={id}>
                        <Link href={href}>
                          <a className="hover:text-accent dark:hover:text-white">
                            {text}
                          </a>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))} */}
          </div>
          <div className="relative h-[100px]">
            <div className="absolute  right-12 flex sm:right-0">
              <a
                href="https://hacken.io/audits/bit5/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/hacken-badge.png"
                  alt=""
                  className="mr-2 h-[50px] w-[125px] sm:h-[100px] sm:w-[250px] "
                />
              </a>
              <a
                href="https://www.quillaudits.com/leaderboard/bit5"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/quillaudits.png"
                  alt=""
                  className="h-[50px] w-[125px] sm:h-[100px] sm:w-[250px] "
                />
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center justify-between space-y-2 py-8 sm:flex-row sm:space-y-0">
            <span className="dark:text-jacarta-400 text-sm">
              <span>© {new Date().getFullYear()} Bit5</span>
              {/* <Link href="https://themeforest.net/user/ib-themes">
                <a className="hover:text-accent dark:hover:text-white">
                  {" "}
                  ib-themes
                </a>
              </Link>*/}
            </span>

            <ul className="dark:text-jacarta-400 flex flex-wrap space-x-4 text-sm">
              <li>
                <Link href="https://docs.bit5.com/legal/terms-of-service">
                  <a
                    className="hover:text-accent dark:hover:text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms and conditions
                  </a>
                </Link>
              </li>
              <li>
                <Link href="https://docs.bit5.com/legal/privacy-policy">
                  <a
                    className="hover:text-accent dark:hover:text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy policy
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
